import React from "react";
import { Badge } from "react-bootstrap";

// Collapsible section header of the room lists (deactivated / completed /
// archived rooms). Styles live in MyProject.css.
const RoomSectionHeader = ({ title, expanded, onClick, badgeCount = 0 }) => (
  <div
    role="button"
    tabIndex={0}
    aria-expanded={!!expanded}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    }}
    onMouseDown={(e) => e.stopPropagation()}
    className="my-project__section-header"
  >
    <span className="my-project__section-title">{title}</span>
    <span className="my-project__section-meta">
      {badgeCount > 0 && (
        <Badge
          className="project-notification pointer message-badge my-project__section-badge"
          pill
        >
          <span className="my-project__section-badge-count">
            {badgeCount > 99 ? "99+" : badgeCount}
          </span>
        </Badge>
      )}
      <img
        src={process.env.PUBLIC_URL + "/assets/img/arrow-right-modern-gray.svg"}
        alt=""
        className={`arrow-icon my-project__section-arrow${expanded ? " my-project__section-arrow--expanded" : ""}`}
      />
    </span>
  </div>
);

export default RoomSectionHeader;
